module.exports = __webpack_public_path__ + "static/media/tools-add-blank-page.68505e0d.svg";